<template>
    <div class="select-industry">
        <v-cascader
            v-model="curSelect"
            :options="industrylist"
            @change="change"
        >
            <template slot="header" slot-scope="props">
                <span>{{ curSelect.length > 0 ?
                    props.item.reduce(
                        (pre, cur) => pre + (pre ? '/' : '') + cur.text,
                        ''
                    ) || $t('全部分类') :
                    $t('全部分类') + '/' + $t('全部分类') }}
                </span>
            </template>
    </v-cascader>
    </div>
</template>

<script>
export default {
    props: {
        industrylist: {
            type: Array,
            default: () => [],
        },
        eIndustry: {
            type: Object,
            default: () => {},
        },
        keyinfo: {
            type: Object,
            default: () => ({
                area: 'area',
                areaDetail: 'areaDetail',
            }),
        }
    },
    data() {
        return {
            curSelect: [-3, -2],
        };
    },
    created() {
        const area = this.eIndustry[this.keyinfo.area];
        const areaDetail = this.eIndustry[this.keyinfo.areaDetail];
        if (this.eIndustry && area && areaDetail) {
            this.curSelect = [area, areaDetail];
        }
    },
    methods: {
        change() {
            this.$emit('change', {
                area: this.curSelect[0],
                areaDetail: this.curSelect[1],
            });
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .v-cascader {
    width: 100%;
}
</style>
